import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';
import { toaster } from '../../helpers/toaster';
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";

import MyModal from '../../components/Modal/Modal';
import Label from '../../components/Label/Label';
import { selectStyles } from '../../helpers/formUtils'
// api
import { addIntervention, updateIntervention } from '../../api/interventions';
import { getSimpleStudyList } from '../../api/studyListApi';
import { getSimpleInterventions } from '../../api/interventions';

const InterventionDetailModal = ({
  mode,
  interventionId = null,
  open = false,
  name = "",
  synonyms = [],
  parentIntervention=[],
  studies = [],
  refreshInterventions = () => {},
  onClose = () => {},
  refreshData,
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

	// processing is for user initiated component api calls
	const [processing, setProcessing] = useState(false);

  const [interventionName, setInterventionName] = useState("");
  const [interventionSynonyms, setInterventionSynonyms] = useState([]);
  const [rootIntervention, setRootIntervention] = useState([]);
  const [interventionStudies, setInterventionStudies] = useState([]);
  const [refreshSimpleInterventions, setRefreshSimpleInterventions] = useState(null);

  const [modalMode, setModalMode] = useState("");

  // store api response
  const [studyList, setStudyList] = useState([]);
  const [interventionList, setInterventionList] = useState([]);

  const onlyAttachment = localStorage.getItem('only_attachment')
  // useEffect(() => {
  //   setInterventionSynonyms(synonyms);
  // })

  const onStudyListChange = (items) => {
    setInterventionStudies(items);
  };

  const onInterventionListChange = (items) => {
    setRootIntervention([items[items.length-1]]);
  };

  const onSynListChange = (items) => {
    setInterventionSynonyms(items);
  };

  const changeInterventionName = (name) => {
    setInterventionName(name);
  };

  const changeInterventionSyn = (name) => {
    setInterventionSynonyms(name);
  };

  const saveIntervention = (e) => {
    // form will handle most of validation, so button type="submit" thats why we preventDefault
		e.preventDefault();

    if (!interventionName) {
      toaster("Intervention name is not valid", "warning")
      return;
    }

    setProcessing(true);

    // convert selected interventions, studies to id array
    // let interventionIdArray = [];
    // if (interventionSynonyms && interventionSynonyms.length) {
    //   interventionIdArray = interventionSynonyms.map(item => {
    //       return ({ id: item.value })
    //     }
    //   );
    // }

    let studyIdArray = [];
    if (interventionStudies && interventionStudies.length) {
      studyIdArray = interventionStudies.map(item => {
        return ({ id: item.value })
        }
      );
    }

    if (modalMode === "create") {
      addIntervention({
        name: interventionName,
        synonyms: interventionSynonyms.map(syn => syn["value"]),
        studies: studyIdArray,
        root_intervention: rootIntervention.map(item => ({id: item.value}))
      }).then(res => {
        toaster("Intervention created successfully", "success")

        onClose();
        setProcessing(false);
        refreshInterventions();
        setRefreshSimpleInterventions(true);
      })
      .catch(error => {
        if(error.message === 'Request failed with status code 400'){
          toaster("Failed to add intervention: intervention already exists", "error")
        }
        else{
          toaster("Failed to add intervention", "error")
        }
        setProcessing(false);
      });
    } else {
      updateIntervention(interventionId, {
        name: interventionName,
        synonyms: interventionSynonyms.map(syn => ({ id: syn.value })),
        studies: studyIdArray,
        root_intervention: rootIntervention.map(item => ({id: item.value}))
      }).then(res => {
        toaster("Intervention updated successfully", "success")

        setProcessing(false);
        onClose();
        refreshInterventions();
        setRefreshSimpleInterventions(true);
      }).catch(error => {
        console.log(error)
        toaster("Failed to update intervention", "error")
        setProcessing(false);
      });
    }
  };

  useEffect(() => setInterventionName(name), [name]);
  useEffect(() => setModalMode(mode), [mode]);

  useEffect(() => {
    let newSynonymList = synonyms.map(element => {
      return({
        value: element?.label?.id,
        label: element?.label?.name
      })
    })
    setInterventionSynonyms(newSynonymList);

  }, [synonyms]);

  useEffect(() => {
    let selParentIntervention = []
    if (parentIntervention && parentIntervention.length) {
      selParentIntervention = interventionList.filter(ele => {
        return parentIntervention.includes(ele.value) || parentIntervention.includes(parseInt(ele.value))
      });
    }
    setRootIntervention(selParentIntervention);
  }, [parentIntervention]);

  useEffect(() => {
    let selectedStudies = [];
    if (studies && studies.length) {
      selectedStudies = studyList.filter(ele => studies.includes(ele.value));
    }
    setInterventionStudies(selectedStudies);
  }, [studies]);

  useEffect(() => {
    getSimpleStudyList().then(res => {
      if (res && res.length) {
        let studies = res.map(item => ({
          value: item.id,
          label: item.org_study_id,
        }));
        setStudyList(studies);
      }
      getSimpleInterventions().then(res => {
        if (res && res.length) {
          let interventions = res.map(item => ({
            value: item.id,
            label: item.name,
          }));
          setInterventionList(interventions);

          setLoading(false);
          setProcessing(false);
        }else {
          setInterventionList(res);

          setLoading(false);
          setProcessing(false);
        }
      }).catch(error => {
        toaster("Failed to get intervention list", "error")

        setLoading(false);
        setProcessing(false);
      });
    }).catch(error => {
      toaster("Failed to get study list", "error")
      setLoading(false);
      setProcessing(false);
    });
    setRefreshSimpleInterventions(false);


  }, [refreshSimpleInterventions, refreshData]);

  const addBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px",
    width: "fit-content",
    marginLeft: "18px"
  };


	const additionalProps = {
		className: 'some-class',
		onSubmit: saveIntervention
	};

  return (
    <MyModal
      modalHeading="Intervention Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <InterventionModalContent>

        {
					processing || loading ?
					<Loading/>
					:
					<></>
				}

				<Form {...additionalProps}>
        <PartWrapper>
            <Label>Name*</Label>
            <InputWrapper>
              <TextInput
                value={interventionName}
                // placeholder="Enter Intervention Name"
                onChange={e => changeInterventionName(e.target.value)}
                required
                />
            </InputWrapper>
          </PartWrapper>
        {onlyAttachment !== 'true' && 
          <>
          <PartWrapper>
            <Label>Related Studies</Label>
            <InputWrapperRelated>
              <Select
                options={studyList}
                isMulti
                onChange={e => onStudyListChange(e)}
                value={interventionStudies}
                classNamePrefix="xogene"
                className="multi-select"
                styles={selectStyles()}
                isDisabled={true}
              />
            </InputWrapperRelated>
            {/* <InputWrapper>
              <Select
                options={studyList}
                isMulti
                onChange={e => onStudyListChange(e)}
                value={interventionStudies}
                classNamePrefix="xogene"
                className="multi-select"
                styles={selectStyles()}
              />
            </InputWrapper> */}
          </PartWrapper>

          <PartWrapper>
            <Label>Root Intervention</Label>
            <InputWrapper>
              <Select
                options={interventionList}
                isMulti
                onChange={e => onInterventionListChange(e)}
                value={rootIntervention}
                classNamePrefix="xogene"
                className="multi-select"
                styles={selectStyles()}
              />
            </InputWrapper>
          </PartWrapper>

          <PartWrapper>
            <Label>Synonyms</Label>
            <InputWrapper>
              <CreatableSelect
                components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                isMulti
                options={interventionList}
                onChange={items => setInterventionSynonyms(items)}
                value={interventionSynonyms}
              />
            </InputWrapper>
          </PartWrapper>
          </>
        }


          <ModalFooter>
            <Button
                kind="secondary"
                onClick={onClose}
                style={addBtnStyle}
              >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              // onClick={() => saveIntervention()}
              style={addBtnStyle}
              disabled={onlyAttachment === "true"}
            >{ (modalMode === "create") ? "Create Intervention" : "Update Intervention" }</Button>
          </ModalFooter>

        </Form>

      </InterventionModalContent>
    </MyModal>
  )
}

export default InterventionDetailModal;

const InterventionModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const PartWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
`

const InputWrapper = styled.div`
  width: 100%;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
const InputWrapperRelated = styled.div`
  width: 100%;
  .xogene__multi-value__remove{
    display: none;
  }
  .xogene__indicators{
    display: none;
  }
`
